<template>
  <v-navigation-drawer
    app
    :mini-variant="isMinimal && !$vuetify.breakpoint.lgAndUp"
    :width="navbarWidth"
    :mini-variant-width="navbarMinWidth"
    v-model="$store.state.showDrawer"
    enable-resize-watcher
    :right="$store.state.rtl"
    :permanent="$vuetify.breakpoint.lgAndUp"
    :touchless="true"
  >
    <v-layout column fill-height>
      <!-- logo -->
      <div class="px-4" style="width: 120px">
        <img
          :src="
            avatar
              ? getImage(avatar)
              : require('@/app/core-module/assets/images/LOGO.png')
          "
          alt="Logo"
          class="mt-6 mb-2"
          height="50"
          width="auto"
          @click="redirect({ routeName: 'Home' })"
        />
      </div>

      <!-- minimise button -->
      <div v-if="!$vuetify.breakpoint.lgAndUp">
        <v-icon
          v-if="!$store.state.rtl"
          @click="isMinimal = !isMinimal"
          color="dark lighten-3"
          class="my-2 mx-auto"
        >
          {{
            isMinimal ? "mdi-chevron-double-right" : "mdi-chevron-double-left"
          }}
        </v-icon>

        <v-icon
          v-else
          @click="isMinimal = !isMinimal"
          color="dark lighten-3"
          class="my-2 mx-auto"
        >
          {{
            !isMinimal ? "mdi-chevron-double-right" : "mdi-chevron-double-left"
          }}
        </v-icon>
      </div>

      <!-- menu items  -->
      <v-container fluid class="fill-height pa-0 align-start mt-3">
        <v-row no-gutters justify="center" align="center">
          <v-col>
            <v-tabs
              :value="selectedTabComputed"
              vertical
              class="px-0 mx-0 text-align-start mb-10"
              background-color="transparent"
            >
              <template v-for="(item, index) in items">
                <v-tab
                  :key="`navbar_${item.routeName}_${index}`"
                  class="px-0"
                  style="min-height: 80px"
                  @click="redirect(item)"
                >
                  <!--collapse view-->
                  <div
                    v-if="!$vuetify.breakpoint.lgAndUp"
                    style="display: contents"
                  >
                    <v-list-item
                      link
                      exact
                      :class="
                        item.routeName === $route.name ||
                        item.relatedRouteNames.includes($route.name)
                          ? 'primary--text'
                          : 'inactive'
                      "
                    >
                      <v-list-item-icon class="mx-0 pa-0">
                        <v-icon v-text="item.icon" />
                      </v-list-item-icon>

                      <v-list-item-content v-if="!isMinimal">
                        <v-list-item-title
                          class="caption font-weight-light text-start ms-2"
                        >
                          {{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>

                  <!--expanded view-->
                  <div v-else :style="{ width: navbarWidth }">
                    <v-list-item
                      link
                      exact
                      :class="
                        item.routeName === $route.name ||
                        item.relatedRouteNames.includes($route.name)
                          ? 'primary--text'
                          : 'inactive'
                      "
                    >
                      <v-list-item-content align="center">
                        <v-icon v-text="item.icon" />

                        <v-list-item-title class="caption font-weight-light">
                          {{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-tab>
              </template>
            </v-tabs>
            <div style="width: 100%">
              <v-divider></v-divider>
              <div>
                <div class="caption my-5 primary--text">
                  <div>{{ $t("poweredBy") }}</div>
                  <div>Salamath</div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import {
  hasPermission,
  isAdmin,
  isEmployee,
  authUser,
} from "@/app/user-module/helpers/authHelper";

export default {
  data() {
    return {
      isMinimal: true,
      version: "1.0",
      // selectedTab: 0,
      right: null,
    };
  },
  created() {
    //update languange
    if (this.$route.params.lang === "ar") {
      // i18n.locale = "ar";
      this.$vuetify.rtl = true;
      this.$store.commit("UPDATE_RTL", true);
    } else {
      // i18n.locale = "en";
      this.$vuetify.rtl = false;
      this.$store.commit("UPDATE_RTL", false);
    }
  },
  computed: {
    avatar() {
      return this.$store.state.authenticatedUser.avatar;
    },
    navbarWidth() {
      return !this.$vuetify.breakpoint.lgAndUp ? null : "120px";
    },
    navbarMinWidth() {
      return "120px";
    },
    selectedTabComputed: {
      get() {
        return this.items.findIndex(
          item =>
            item.routeName === this.$route.name ||
            item.relatedRouteNames.includes(this.$route.name)
        );
      },
      // set(value) {
      //   this.selectedTab = value;
      // },
    },
    items() {
      const currentRole = this.$store.state.authenticatedUserRole;
      const currentPermissions = this.$store.state.authenticatedUserPermissions;
      const isOrganizationManager =
        this.$store.state.authenticatedUser?.isOrganizationManager;

      const canShowMenu = item => {
        const restrictOrganizationManager =
          item.restrictOrganizationManager && isOrganizationManager;

        return restrictOrganizationManager || item.requiredPermissions?.length
          ? hasPermission({
              currentRole,
              currentPermissions,
              requiredPermission: item.requiredPermissions,
              requiredAll: item.requiredAll,
              restrictOrganizationManager,
            })
          : true;
      };

      const items = [
        {
          name: this.$t("navBarItems.home"),
          icon: " mdi-home-outline",
          routeName: "Home",
          relatedRouteNames: [],
        },
        {
          name: this.$t("navBarItems.courses"),
          icon: "mdi-book-open-page-variant-outline",
          routeName: "Courses",
          relatedRouteNames: ["CourseDetails"],
          requiredPermissions: ["GET_TRAININGS"],
          restrictOrganizationManager: true,
        },
        {
          name: this.$t("user.registration.registrations"),
          icon: "mdi-file-plus-outline",
          routeName: "Registrations",
          relatedRouteNames: ["Registration"],
          requiredPermissions: ["GET_TRAINING_REGISTRATIONS"],
        },
        {
          name: this.$t("quiz.quizzes"),
          icon: "mdi-comment-question-outline",
          routeName: "Quizzes",
          relatedRouteNames: ["QuizDetails"],
          requiredPermissions: ["GET_QUIZZES"],
          restrictOrganizationManager: true,
        },
        {
          name: this.$t("reports.reports"),
          icon: "mdi-file-chart-outline",
          routeName: "Reports",
          relatedRouteNames: [],
          requiredPermissions: [
            "GET_REGISTRATION_REPORTS",
            "GET_REVENUE_REPORTS",
            "GET_QUIZ_REPORTS",
            "GET_ASSESSMENT_REPORTS",
            "GET_FEEDBACK_REPORTS",
            "GET_TRAINING_MATRIX_REPORTS",
          ],
          requiredAll: false,
        },
        {
          name: this.$t("user.registration.attendance"),
          icon: "mdi-account-check-outline",
          routeName: "Attendance",
          relatedRouteNames: [],
          requiredPermissions: ["GET_TRAINING_REGISTRATION_ATTENDANCE"],
          requiredAll: false,
          restrictOrganizationManager: true,
        },
        {
          name: this.$t("user.certificatesAndProfileCard.certificates"),
          icon: "mdi-certificate-outline",
          routeName: "Certificates",
          relatedRouteNames: [],
          requiredPermissions: [
            "DOWNLOAD_CERTIFICATE",
            "DOWNLOAD_PROFILE_CARD",
          ],
          requiredAll: false,
        },
        {
          name: this.$t("invoice.invoices"),
          icon: "mdi-file-document-outline",
          routeName: "Invoices",
          relatedRouteNames: [],
          requiredPermissions: ["GENERATE_INVOICE", "DOWNLOAD_INVOICE"],
          requiredAll: false,
          restrictOrganizationManager: true,
        },
        {
          name: this.$t("user.subRoles.subRoles"),
          icon: "mdi-account-key-outline",
          routeName: "EmployeesRoles",
          relatedRouteNames: ["EmployeeProfile"],
          requiredPermissions: ["GET_EMPLOYEES"],
        },
        {
          name: this.$t("organization.organizations"),
          icon: "mdi-domain",
          routeName: "Organizations",
          relatedRouteNames: ["OrganizationProfile"],
          requiredPermissions: [
            "CREATE_ORGANIZATION",
            "UPDATE_ORGANIZATION",
            "ENABLE_DISABLE_ORGANIZATION",
            "DELETE_ORGANIZATION",
          ],
          requiredAll: false,
          restrictOrganizationManager: true,
        },
        {
          name: this.$t("trainingCategory.trainingCategories"),
          icon: "mdi-shape-outline",
          routeName: "Categories",
          relatedRouteNames: [],
          requiredPermissions: [
            "CREATE_TRAINING_CATEGORY",
            "UPDATE_TRAINING_CATEGORY",
            "ENABLE_DISABLE_TRAINING_CATEGORY",
            "DELETE_TRAINING_CATEGORY",
          ],
          requiredAll: false,
          restrictOrganizationManager: true,
        },
        {
          name: this.$t("notifications.notifications"),
          icon: "mdi-bell-outline",
          routeName: "Notifications",
          relatedRouteNames: [],
          restrictOrganizationManager: true,
        },
        // {
        //   name: this.$t("navBarItems.profile"),
        //   icon: "mdi-account-circle-outline",
        //   routeName: "Profile",
        //   relatedRouteNames: [],
        // },
        {
          name: this.$t("navBarItems.settings"),
          icon: "mdi-tune-vertical-variant",
          routeName: "Settings",
          relatedRouteNames: ["EmployeeBasicProfile"],
        },
        {
          name: "Active Sessions",
          icon: "mdi-shield-account-outline",
          routeName: "ActiveSessions",
          relatedRouteNames: [],
        },
        {
          name: "Login Audit",
          icon: "mdi-shield-search",
          routeName: "LoginAudit",
          relatedRouteNames: [],
        },
      ];

      return items.reduce((result, item) => {
        if (canShowMenu(item)) result.push(item);
        return result;
      }, []);
    },
  },
  methods: {
    redirect(item) {
      if (item.routeName !== this.$route.name) {
        if (item.routeName === "Settings") {
          if (isAdmin() && this.$route.name !== item.routeName)
            this.$router.push({ name: item.routeName });
          else if (isEmployee() && this.$route.name !== "EmployeeBasicProfile")
            this.$router.push({
              name: "EmployeeBasicProfile",
              params: { userId: authUser()._id },
            });
        } else this.$router.push({ name: item.routeName });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* nav items opacity  */
.inactive {
  color: #281166;
}

>>> .v-list-item--active {
  opacity: 1 !important;
}

/* change navifation drawer divider color */
>>> .v-navigation-drawer__border {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

/* remove ligh background on selected tab */
>>> .v-list-item--link::before {
  opacity: 0 !important;
}

/* align navigation title to left */
>>> .v-tab {
  text-align: start;
}

/* tab selector shape  */
>>> .v-tabs-slider-wrapper {
  width: 4px !important;
  height: 80px !important;
  left: auto !important;
  right: 0;
}
>>> .v-tabs-slider {
  border-radius: 0 0 0 0 !important;
}
</style>
